var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#209D7F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3008 32.9759C45.7536 31.3964 45.9964 29.7263 45.9964 27.9983C45.9964 18.0572 37.9392 10 27.9983 10C21.2017 10 15.2857 13.7677 12.2244 19.3252L17.876 24.0964C19.4411 20.0352 23.3864 17.1515 27.9983 17.1515C32.0413 17.1515 35.5699 19.365 37.4356 22.6437L34.0265 23.5095L39.0333 27.6758L45.3008 32.9759ZM43.4532 37.2292C40.3085 42.4824 34.5627 46 27.9983 46C18.0572 46 10 37.9428 10 28.0019C10 26.5093 10.1811 25.06 10.5253 23.6725L15.8581 28.1758L21.1727 32.5992L18.5172 33.2731C20.3686 36.5989 23.9225 38.8487 27.9983 38.8487C32.3782 38.8487 36.1532 36.2509 37.8669 32.5123L43.4532 37.2292Z",
    fill: "#173937"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3016 32.9759C45.7544 31.3964 45.997 29.7263 45.997 27.9983C45.997 18.0572 37.94 10 27.9989 10C21.2025 10 15.2864 13.7677 12.2251 19.3252L17.8767 24.0964C19.4417 20.0352 23.387 17.1515 27.9989 17.1515C32.0419 17.1515 35.5707 19.365 37.4364 22.6437L34.0273 23.5095L39.0339 27.6758L45.3016 32.9759Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwop);
export default __webpack_public_path__ + "static/media/SWOP.1452862e9597b3c8e23e5a57b753117e.svg";
export { ForwardRef as ReactComponent };